import React from 'react';
import cn from 'clsx';

import Image from '../../../../library/image/image';
import Typography from '../../../../library/typography/typography';

import { useMyAccount } from '../../../../shared/hooks/hooks';

import { PaymentType } from '../../../../shared/types/graphql-types';

import styles from './easy-pay-options.scss';

interface EasyPayOptionsProps {
  className?: string;
}

function EasyPayOptions(props: EasyPayOptionsProps) {
  const { className = '' } = props;
  const { isFleetAccount, user } = useMyAccount();

  const showArChargeMessage =
    process.env.__FF_FLEET_ACCOUNT__ === 'true' &&
    isFleetAccount &&
    user?.isB2bChargeAuthorized &&
    user?.supportedPaymentType?.includes(PaymentType.ArCharge);

  if (
    process.env.__FF_AFFIRM_PAY_CHECKOUT__ !== 'true' &&
    process.env.__FF_APPLE_PAY_CHECKOUT__ !== 'true' &&
    process.env.__FF_GOOGLE_PAY_CHECKOUT__ !== 'true' &&
    process.env.__FF_PAYPAL_CHECKOUT__ !== 'true'
  ) {
    return null;
  }

  return (
    <aside
      className={cn(
        `${styles['container']} ${
          showArChargeMessage ? styles['container--fleet'] : ''
        }`,
        className
      )}
    >
      <Typography className={styles['title']} tag="span" weight="bold">
        Easy Pay Options
      </Typography>
      <div className={styles['payment-options-container']}>
        {process.env.__FF_AFFIRM_PAY_CHECKOUT__ === 'true' && (
          <Image
            alt="affirm logo"
            className={`${styles['payment-logo']} ${styles['affirm-logo']}`}
            loading="lazy"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/Affirm-Logo.svg"
          />
        )}
        {process.env.__FF_PAYPAL_CHECKOUT__ === 'true' && (
          <Image
            alt="paypal logo"
            className={styles['payment-logo']}
            loading="lazy"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/badges/paypal-logo.svg"
          />
        )}
        {process.env.__FF_APPLE_PAY_CHECKOUT__ === 'true' && (
          <Image
            alt="apple pay logo"
            className={styles['payment-logo']}
            loading="lazy"
            src="https://discounttire.scene7.com/is/content/discounttire/discounttire/customerservice/payments/Apple_Pay.svg"
          />
        )}
        {process.env.__FF_GOOGLE_PAY_CHECKOUT__ === 'true' && (
          <Image
            alt="google pay logo"
            className={styles['payment-logo']}
            loading="lazy"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/badges/google-pay.svg"
          />
        )}
        {showArChargeMessage && (
          <Typography className={styles['ar-charge-message']}>
            <span className={styles['ar-charge-text']}>
              Fleet B2B Charge Account
            </span>
            &nbsp;is available as a payment option for your company.
          </Typography>
        )}
      </div>
    </aside>
  );
}

export default EasyPayOptions;
